/* eslint-disable */

import * as XLSX from 'xlsx'
import { StyleSheet } from 'aphrodite'
import React, { useState } from 'react'
import { TOTAL_EXPENSE_CATEGORY_LIST, TOTAL_EXPENSE_LIST } from '../../urls'
import { useLoad } from '../../hooks/request'
import { useQueryParams } from '../../hooks/queryString'
import DateFilter from '../../components/common/DateFilter'
import Button from '../../components/common/Button'
import { useModal } from '../../hooks/modal'
import Table from '../../components/common/Table'
import Layout from '../../components/Layout'
import TotalExpenseItem from './TotalExpenseItem'
import CustomFilterSelect from '../../components/common/CustomFilterSelect'
import Search from '../../components/Search'
import { isEmpty } from 'lodash'
import queryString from 'querystring'
import { useHistory } from 'react-router-dom'
import TotalExpenseCreate from './TotalExpenseCreate'

export default function TotalExpense() {
    const [page, setPage] = useState(1)
    const [params, setParams] = useState({})
    const [activeTab, setActiveTab] = useState('active') // Add tab state
    const [filters, setFilters] = useState({
        expense_date_month: '',
        expense_date_year: new Date().getFullYear()
    })
    const [showFilters, setShowFilters] = useState(false)

    const searchParam = useQueryParams()
    const expense = useLoad(
        {
            url: TOTAL_EXPENSE_LIST,
            params: { page, spaceType: activeTab, ...params, ...searchParam, ...filters }, // Add filters to expense call
        },
        [searchParam, page, params, activeTab, filters], // Add filters to dependencies
    )
    const expenseSize = useLoad(
        {
            url: TOTAL_EXPENSE_LIST,
            params: { page, spaceType: activeTab, ...params, ...searchParam, ...filters, size: 10000000 }, // Add filters to expense call
        },
        [searchParam, page, params, activeTab, filters], // Add filters to dependencies
    )
    const { response: subcategoryResponse } = useLoad({
        url: TOTAL_EXPENSE_CATEGORY_LIST,
        params: { size: 1000 },
    })
    const subcategoryItems = subcategoryResponse ? subcategoryResponse.results : []
    const productList = expense.response ? expense.response.results : []
    const [showCreateModal, setShowCreateModal] = useModal(<TotalExpenseCreate expenseReport={expense} onCancel={() => setShowCreateModal()} />, styles.modal)

    function format(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true,
        })
            .format(value)
            .replace(/,/g, ' ')
    }

    console.log(productList[0])

    const exportToExcel = (response) => {
        const headers = [
            { text: '№', key: 'index' },
            { text: 'Сана', key: 'createdAt' },
            { text: 'Масул Ходим', key: 'assigned' },
            { text: 'Статус', key: 'status' },
            { text: 'Категория', key: 'category' },
            { text: 'Сумма', key: 'amount' },
            { text: 'Тўлов тури', key: 'paymentType' },
            { text: 'Тур', key: 'types' },
            { text: 'Ҳолат', key: 'spaceType' },
            { text: 'Эслатма', key: 'comment' },
        ]

        const data = response.results.map((item, index) => ({
            index: index + 1,
            createdAt: new Date(item.createdAt).toLocaleDateString('en-GB'),
            assigned: item.selectAssigned?.username || '',
            status: item.status === 'expenses' ? 'Чиқим' : 'Кирим',
            category: item.selectCategory?.name || '',
            amount: parseInt(item.amount, 10),
            paymentType: item.paymentType === 'click' ? 'Click' : item.paymentType === 'naqd' ? 'Нақд' : item.paymentType === 'perichislena' ? 'Перечислена' : item.paymentType || '',
            types: item.types === 'dom' ? 'DOM' : item.types === 'arenda' ? 'ARENDA' : item.types === 'boshqa' ? 'BOSHQA' : item.types || '',
            spaceType: item.spaceType === 'active' ? 'Фаол' : item.spaceType === 'archive' ? 'Архив' : item.spaceType || '',
            comment: item.comment || '',
        }))

        // Add financial summary data to the top of the sheet
        const summaryHeaders = ['Тур', 'Сумма']
        const summaryData = [
            ['Кирим:', format(financial.response ? financial.response?.total?.totalIncomeSum : 0) + ' Сум'],
            ['Чиқим:', format(financial.response ? financial.response?.total?.totalExpensesSum : 0) + ' Сум'],
            ['Баланс:', format(financial.response ? financial.response?.total?.balance : 0) + ' Сум'],
            [''], // Empty row for separation
            ['DOM:', format(expense.response ? expense.response?.domTotal : 0) + ' Сум'],
            ['ARENDA:', format(expense.response ? expense.response?.arendaTotal : 0) + ' Сум'],
            ['BOSHQA:', format(expense.response ? expense.response?.boshqaTotal : 0) + ' Сум'],
            [''], // Empty row for separation
        ]

        const rows = [
            ['Молиявий хисобот'], // Title
            [''], // Empty row
            summaryHeaders,
            ...summaryData,
            ['Батафсил маълумот'], // Detail section title
            [''], // Empty row
            headers.map((header) => header.text),
            ...data.map((item) => headers.map((header) => item[header.key]))
        ]

        const ws = XLSX.utils.aoa_to_sheet(rows)

        // Apply border styles with 2px black borders
        const range = XLSX.utils.decode_range(ws['!ref'])
        const borderStyle = {
            top: { style: 'medium', color: { rgb: '000000' } },
            bottom: { style: 'medium', color: { rgb: '000000' } },
            left: { style: 'medium', color: { rgb: '000000' } },
            right: { style: 'medium', color: { rgb: '000000' } },
        }

        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C })
                if (!ws[cellAddress]) ws[cellAddress] = { v: '' } // Create empty cells if needed
                ws[cellAddress].s = { border: borderStyle }
            }
        }

        // Set column widths
        const maxCols = Math.max(summaryHeaders.length, headers.length)
        const colWidths = Array(maxCols).fill(0).map((_, index) => {
            const allRows = [summaryHeaders, ...summaryData.map(row => Array.isArray(row) ? row : [row]), headers.map(h => h.text), ...data.map(item => headers.map(header => item[header.key]))]
            const maxLength = Math.max(...allRows.map((row) => (row[index] ? row[index].toString().length : 0)))
            return { wch: maxLength + 2 }
        })
        ws['!cols'] = colWidths

        // Create workbook and append sheet
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Умумий Чиқимлар')

        // Save to file
        XLSX.writeFile(wb, 'УмумийЧиқимлар.xlsx')
    }
    const history = useHistory()

    function onSearch(query) {
        const search = !isEmpty(query) ? query : undefined
        history.push(`?${queryString.stringify({ ...searchParam, search })}`)
    }

    const handleFilterChange = (name, value) => {
        setFilters((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const clearFilters = () => {
        setFilters({
            expense_date_month: '',
            expense_date_year: new Date().getFullYear()
        })
    }

    const months = [
        { value: 1, label: 'Yanvar' },
        { value: 2, label: 'Fevral' },
        { value: 3, label: 'Mart' },
        { value: 4, label: 'Aprel' },
        { value: 5, label: 'May' },
        { value: 6, label: 'Iyun' },
        { value: 7, label: 'Iyul' },
        { value: 8, label: 'Avgust' },
        { value: 9, label: 'Sentabr' },
        { value: 10, label: 'Oktabr' },
        { value: 11, label: 'Noyabr' },
        { value: 12, label: 'Dekabr' }
    ]

    const financial = useLoad({
        url: '/main/financial-summary',
        params: { ...searchParam, ...filters }, // Add month filters to financial summary
    }, [searchParam, filters]) // Add filters dependency

    return (
        <Layout showCreateModal={showCreateModal}>
            <div className="">
                <div className="is-flex is-flex-direction-column">
                    <div className="level mb-4">
                        <div className="level-left">
                            <div className="level-item">
                                <Search onSearch={onSearch} />
                            </div>
                            <div className="level-item mr-2">
                                <DateFilter name="start_date" />
                            </div>
                            <div className="level-item">
                                <DateFilter name="end_date" />
                            </div>
                            <div className="level-item">
                                <CustomFilterSelect setSearchParams={setParams} placeholder="Категория" name="category" options={subcategoryItems} />
                            </div>
                        </div>

                        <div className="level-right">
                            <div className="level-item">
                                <Button text={showFilters ? 'Фильтрни яшириш' : 'Ой бўйича фильтр'} className="button is-info is-outlined mr-2" onClick={() => setShowFilters(!showFilters)} />
                            </div>
                            <div className="level-item">
                                <Button text="Excel юклаб олиш" className="button is-success is-outlined mr-2" onClick={() => exportToExcel(expenseSize.response)} disabled={!expenseSize.response || !expenseSize.response.results || expenseSize.response.results.length === 0} />
                            </div>
                            <div className="level-item">
                                <Button text="Қўшиш" className="button is-link is-outlined" onClick={showCreateModal} />
                            </div>
                        </div>
                    </div>

                    {/* Active/Archive Tabs */}
                    <div className="tabs is-boxed mb-4">
                        <ul>
                            <li className={activeTab === 'all' ? 'is-active' : ''}>
                                <a
                                    onClick={() => {
                                        setActiveTab('all')
                                        setPage(1) // Reset to first page when switching tabs
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <span className="icon is-small">
                                        <ion-icon name="list-outline"></ion-icon>
                                    </span>
                                    <span>Ҳаммаси {format(expense.response ? expense.response.count : 0)}</span>
                                </a>
                            </li>
                            <li className={activeTab === 'active' ? 'is-active' : ''}>
                                <a
                                    onClick={() => {
                                        setActiveTab('active')
                                        setPage(1) // Reset to first page when switching tabs
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <span className="icon is-small">
                                        <ion-icon name="checkmark-circle"></ion-icon>
                                    </span>
                                    <span>Фаол {format(expense.response ? expense.response.activeTotal : 0)}</span>
                                </a>
                            </li>
                            <li className={activeTab === 'archive' ? 'is-active' : ''}>
                                <a
                                    onClick={() => {
                                        setActiveTab('archive')
                                        setPage(1) // Reset to first page when switching tabs
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <span className="icon is-small">
                                        <ion-icon name="archive"></ion-icon>
                                    </span>
                                    <span>Архив {format(expense.response ? expense.response?.archiveTotal : 0)}</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Month Filter Section */}
                    {showFilters && (
                        <div className="box mb-4">
                            <h3 className="subtitle is-5 mb-3">Харажат санаси бўйича фильтр</h3>

                            <div className="columns">
                                <div className="column is-4">
                                    <label className="label">Ой</label>
                                    <div className="select is-fullwidth">
                                        <select value={filters.expense_date_month} onChange={(e) => handleFilterChange('expense_date_month', e.target.value)}>
                                            <option value="">Барча ойлар</option>
                                            {months.map((month) => (
                                                <option key={month.value} value={month.value}>
                                                    {month.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="column is-4">
                                    <label className="label">Йил</label>
                                    <input className="input" type="number" value={filters.expense_date_year} onChange={(e) => handleFilterChange('expense_date_year', e.target.value)} placeholder="Йилни киритинг" />
                                </div>

                                <div className="column is-4">
                                    <label className="label">&nbsp;</label>
                                    <div className="field">
                                        <Button text="Фильтрни тозалаш" className="button is-light" onClick={clearFilters} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="columns is-mobile is-multiline">
                        <div className="column is-4-desktop is-12-mobile">
                            <div
                                style={{
                                    padding: '15px',
                                    borderRadius: '8px',
                                    backgroundColor: '#f0fff4',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                }}
                            >
                                <p className="has-text-success has-text-centered">
                                    <span className="icon-text">
                                        <ion-icon name="arrow-down-outline"></ion-icon>
                                        <b className="ml-2">Кирим:</b>
                                    </span>
                                    <span className="ml-2 has-text-weight-bold">{format(financial.response ? financial.response?.total.totalIncomeSum : 0)} Сум</span>
                                </p>
                            </div>
                        </div>

                        <div className="column is-4-desktop is-12-mobile">
                            <div
                                style={{
                                    padding: '15px',
                                    borderRadius: '8px',
                                    backgroundColor: '#fff5f5',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                }}
                            >
                                <p className="has-text-danger has-text-centered">
                                    <span className="icon-text">
                                        <ion-icon name="arrow-up-outline"></ion-icon>
                                        <b className="ml-2">Чиқим:</b>
                                    </span>
                                    <span className="ml-2 has-text-weight-bold">{format(financial.response ? financial.response?.total?.totalExpensesSum : 0)} Сум</span>
                                </p>
                            </div>
                        </div>

                        <div className="column is-4-desktop is-12-mobile">
                            <div
                                style={{
                                    padding: '15px',
                                    borderRadius: '8px',
                                    backgroundColor: '#f0f7ff',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                }}
                            >
                                <p className="has-text-info has-text-centered">
                                    <span className="icon-text">
                                        <ion-icon name="wallet-outline"></ion-icon>
                                        <b className="ml-2">Баланс:</b>
                                    </span>
                                    <span className="ml-2 has-text-weight-bold">{format(financial.response ? financial.response?.total?.balance : 0)} Сум</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Type breakdown section */}
                    <div className="columns is-mobile is-multiline">
                        <div className="column is-4-desktop is-12-mobile">
                            <div
                                style={{
                                    padding: '15px',
                                    borderRadius: '8px',
                                    backgroundColor: '#f9f7ff',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                }}
                            >
                                <p className="has-text-purple has-text-centered">
                                    <span className="icon-text">
                                        <ion-icon name="home-outline"></ion-icon>
                                        <b className="ml-2">DOM:</b>
                                    </span>
                                    <span className="ml-2 has-text-weight-bold">{format(expense.response ? expense.response?.domTotal : 0)} Сум</span>
                                </p>
                            </div>
                        </div>

                        <div className="column is-4-desktop is-12-mobile">
                            <div
                                style={{
                                    padding: '15px',
                                    borderRadius: '8px',
                                    backgroundColor: '#fff9f0',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                }}
                            >
                                <p className="has-text-warning has-text-centered">
                                    <span className="icon-text">
                                        <ion-icon name="business-outline"></ion-icon>
                                        <b className="ml-2">ARENDA:</b>
                                    </span>
                                    <span className="ml-2 has-text-weight-bold">{format(expense.response ? expense.response?.arendaTotal : 0)} Сум</span>
                                </p>
                            </div>
                        </div>

                        <div className="column is-4-desktop is-12-mobile">
                            <div
                                style={{
                                    padding: '15px',
                                    borderRadius: '8px',
                                    backgroundColor: '#f0f5ff',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                }}
                            >
                                <p className="has-text-grey has-text-centered">
                                    <span className="icon-text">
                                        <ion-icon name="ellipsis-horizontal-outline"></ion-icon>
                                        <b className="ml-2">BOSHQA:</b>
                                    </span>
                                    <span className="ml-2 has-text-weight-bold">{format(expense.response ? expense.response?.boshqaTotal : 0)} Сум</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="mt-4 mb-4">
                        <Table
                            loading={expense.loading}
                            items={productList}
                            columns={{
                                index: '№',
                                date: 'Сана',
                                subcategory: 'Масул Ходим',
                                status: 'Статус',
                                category: 'Категория',
                                amount: 'Сумма',
                                paymentType: 'Тўлов тури',
                                types: 'Тур',
                                spaceType: 'Ҳолат',
                                note: 'Эслатма',
                                buttons: '',
                            }}
                            totalCount={expense.response ? expense.response.count : 0}
                            activePage={page}
                            onPageChange={setPage}
                            renderItem={(item, index) => <TotalExpenseItem expenseReport={expense} index={index} key={item.id} item={item} />}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

const styles = StyleSheet.create({
    space: { marginTop: '2rem' },
    emptyImg: { width: '330px', height: '300px' },
    loader: { marginTop: '2rem' },
    modal: { width: 800 },
    checkmark: { marginRight: '3px' },
})
